"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumberShort = void 0;
var formatNumberShort = function (value, fixedCount) {
    if (fixedCount === void 0) { fixedCount = 2; }
    var abs = Math.floor(value);
    var format = function (num, suffix) {
        var result = Number(num.toFixed(2));
        return result % 1 === 0
            ? "".concat(result.toFixed(0)).concat(suffix)
            : "".concat(result.toString() + suffix);
    };
    if (abs >= 1000000000000) {
        return format(abs / 1000000000000, 'T');
    }
    else if (abs >= 1000000000) {
        return format(abs / 1000000000, 'B');
    }
    else if (abs >= 1000000) {
        return format(abs / 1000000, 'M');
    }
    else if (abs >= 1000) {
        return format(abs / 1000, 'K');
    }
    else {
        return Number(value).toFixed(fixedCount);
    }
};
exports.formatNumberShort = formatNumberShort;
